module.exports = __webpack_public_path__ + "img/829-17c5d6.png";